<div class="footer"> <span class="footer-version">{{ version}}</span> </div> 